import { Row } from "v2/components/base/Flex/ui";
import CabalTownLogo from "assets/icons/cabal-town-logo-v2.png";

const AppSideBarHeader = () => {
  return (
    <Row type="cc">
      <img src={CabalTownLogo} alt="Cabal Town Logo" height={44} />
    </Row>
  );
};

export default AppSideBarHeader;
